// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const AcceptPaymentCustomPageSelector: MarkdocTagRegistration = {
  tag: 'accept-payment-custom-page-selector',
  component: 'AcceptPaymentCustomPageSelector',
  attributes: {
    showReact: {type: Boolean},
    showPlugins: {type: Boolean},
  },
};
